import React, { Component } from "react";
import { connect } from "react-redux";
import { change } from "redux-form";

import { saveTour } from "@/helpers/forms";
import { redirectTo } from "@/helpers/redirect";

import { saveTourRequest } from "@/actions/tour";

import Title from "@/components/Title/index";
import { FormDetails } from "@/components/Forms/index";

import { GridRow, GridCol } from "@/components/Styled/Grid/index";
import { generateAIDescription } from "./http";
import { Badge, Button, Icon, InputNumber, Loader, Message } from "rsuite";

class Details extends Component<any> {
  formName: string = "details";

  state = {
    generatingDescription: false,
    descriptionLength: 200,
  };

  handleSubmit = (values) => {
    // @ts-ignore
    saveTour(this.props, this.formName, values);
  };

  handleSaveAndNext = () => {
    // @ts-ignore
    saveTour(this.props, this.formName, this.props.formValues, true);
  };

  handleGenerateDescription = async () => {
    this.setState({ generatingDescription: true });

    const response = await generateAIDescription(
      this.props.id,
      this.state.descriptionLength
    );

    if (response.status === "success") {
      this.props.updateDescription(response.data);
    }

    this.setState({ generatingDescription: false });
  };

  render() {
    const { id, currentTour, initialValues, loading } = this.props;
    // @ts-ignore
    const skipUrl = `/${redirectTo({
      currentPage: this.formName,
      activePages: currentTour.settings,
    })}/${id}`;

    return (
      <GridRow>
        <GridCol>
          <Title name="Details" />
          <FormDetails
            onSubmit={this.handleSubmit}
            onSaveAndNext={this.handleSaveAndNext}
            skipUrl={skipUrl}
            initialValues={initialValues}
            loading={loading}
            onGenerateDescription={this.handleGenerateDescription}
            aiDescription={
              <div>
                <Message
                  type="info"
                  description={
                    <>
                      <Badge content="NEW" />
                      <span style={{ marginLeft: 10 }}>
                        Now you can generate description with AI! Click the
                        button below to generate description based on photos.
                      </span>
                    </>
                  }
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 15,
                    marginTop: 20,
                    marginBottom: 15,
                  }}
                >
                  <Button
                    appearance="primary"
                    size="sm"
                    disabled={
                      isNaN(this.state.descriptionLength) ||
                      this.state.descriptionLength < 10
                    }
                    onClick={this.handleGenerateDescription}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {this.state.generatingDescription ? (
                        <>
                          <Loader />
                          <span style={{ marginLeft: 10 }}>Generating...</span>
                        </>
                      ) : (
                        <>
                          <Icon icon="flow" />
                          <span style={{ marginLeft: 10 }}>
                            Generate description with AI
                          </span>
                        </>
                      )}
                    </div>
                  </Button>

                  <div style={{ width: 170 }}>
                    <InputNumber
                      size="sm"
                      prefix="Length:"
                      value={this.state.descriptionLength}
                      min={10}
                      onChange={(value) =>
                        this.setState({ descriptionLength: value })
                      }
                    />
                  </div>
                </div>
              </div>
            }
          />
        </GridCol>
      </GridRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const form = state.form.details;
  const id = ownProps.match.params.id;
  const currentTour = state.tour[id];
  const formValues = form && form.values;
  const initialValues = currentTour ? currentTour.details : null;

  return {
    id,
    initialValues,
    formValues,
    currentTour,
    loading: state.tour.loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveTourRequest: (json, options) => dispatch(saveTourRequest(json, options)),
  updateDescription: (description) =>
    dispatch(change("details", "description", description)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Details);
